var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24077 11C5.24077 10.2855 5.35936 9.60037 5.57128 8.9579L1.86394 6.12695C1.14138 7.59391 0.734375 9.247 0.734375 11C0.734375 12.7515 1.14103 14.4034 1.86239 15.8695L5.56767 13.0331C5.35781 12.3935 5.24077 11.711 5.24077 11Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7494 4.50003C13.3016 4.50003 14.7035 5.05003 15.8051 5.94997L19.0095 2.75C17.0569 1.04998 14.5533 0 11.7494 0C7.39611 0 3.65473 2.48944 1.86328 6.127L5.57045 8.95795C6.42467 6.36505 8.85962 4.50003 11.7494 4.50003Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7494 17.5009C8.8598 17.5009 6.42484 15.6359 5.57063 13.043L1.86328 15.8734C3.65473 19.5115 7.39611 22.0009 11.7494 22.0009C14.4361 22.0009 17.0013 21.0468 18.9265 19.2593L15.4075 16.5389C14.4146 17.1644 13.1642 17.5009 11.7494 17.5009Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2648 10.9999C22.2648 10.3499 22.1646 9.64986 22.0144 9H11.75V13.25H17.6584C17.3629 14.699 16.5589 15.813 15.4082 16.5379L18.9272 19.2584C20.9494 17.3815 22.2648 14.5854 22.2648 10.9999Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.22d79e389cf34c285f07523599fe34e6.svg";
export { ForwardRef as ReactComponent };